/**
 * Variante visual del detalle de avance del tracking de cortes.
 */
export enum TipoVarianteDetalleEnum {
  /**
   * Corte imprevisto en curso.
   */
  IMPREVISTO = 'imprevisto',
  /**
   * Corte programado en curso.
   */
  PROGRAMADO = 'programado',
  /**
   * Próximo corte programado.
   */
  FUTURO = 'futuro',
}
